
	import iconfont from '../components/iconfont.vue';
	import {
		ElMessage
	} from 'element-plus';
	import { setCookie, getCookie } from '../util/index.js';
	export default {
		data() {
			return {
				isloading: false,
				viewmode: '2',
				keyword: '',
				clientWidth: document.documentElement.clientWidth,
				clientHeight: document.documentElement.clientHeight,
				categories: [],
				artlist: [],
				curpage: 1,
				pgcurpage: 0,
				total: 0,
				value: [],
				optcateid: '0',
				selectedrows: [],
				pagesize: 10,
			}
		},
		watch: {
			viewmode(val) {
				setCookie('articleviewmode', val);
			},
			clientWidth(val) {
				// 为了避免频繁触发resize函数导致页面卡顿，使用定时器
				if (!this.timerw) {
					// 一旦监听到的clientWidth值改变，就将其重新赋给data里的clientWidth
					this.clientWidth = val
					this.timerw = true
					let that = this
					setTimeout(function() {
						// 打印clientWidth变化的值
						console.log(that.clientWidth)
						if (that.clientWidth < 992 && !that.isCollapse)
							that.isCollapse = true;
						if(that.clientWidth < 738)
							that.viewmode = '1';

						that.curclass = (that.isCollapse ? "el-icon-s-unfold" : "el-icon-s-fold")
						//else if( that.clientWidth >= 992)
						//	that.isCollapse = false;
						that.timerw = false
					}, 400)
				}
			},
			clientHeight(val) {
				if (!this.timerh) {
					// 一旦监听到的clientHeight值改变，就将其重新赋给data里的clientHeight
					this.clientHeight = val
					this.timerh = true
					let that = this
					setTimeout(function() {
						// 打印clientHeight变化的值
						console.log(that.clientHeight)

						//else if( that.clientHeight >= 992)
						that.drawerMenuHeight = that.clientHeight;
						//	that.isCollapse = false;
						that.timerh = false
					}, 400)
				}
			},
		},
		beforeCreate() {
			this.PAGELANG = this.LANG.pages.ArticleList;
		},
		methods: {
			onPageChanged(val) {
				this.curpage = val;
				this.Refresh();
				console.log(this.curpage + '-' + val);
			},
			DeleteSelected() {
				if(this.selectedrows.length <= 0) {
					ElMessage({
						message: this.PAGELANG.qxxzyscdwz,
						type: "warning"
					})
					return;
				}
				
				this.$confirm(this.PAGELANG.zzscxzdwz, {
					type: 'warning',
					callback: (act) => {
						console.log(act);
						if(act == 'confirm') {
							let delids = Array();
							for(var key in this.selectedrows) {
								delids.push(this.selectedrows[key].ID);
							}
							this.isloading = true;
							this.axios.post(this.actions.delartids, delids).then((response) => {
								//console.log(response.data);
								this.isloading = false;
								if (response.data.retinfo == "ok") {
									this.$message(this.LANG.system.caozuochenggong);
									this.$router.go(0);
								} else {
									this.$message(this.PAGELANG[response.data.retinfo]);
								}
							});
						}
					}
				});
			},
			handleSelChange(val) {
				this.selectedrows = val;
				console.log(this.selectedrows);
			},
			formatDate(date) {
				var datetime = new Date(date * 1000);
				var year = datetime.getFullYear();
				var month = ("0" + (datetime.getMonth() + 1)).slice(-2);
				var day = ("0" + datetime.getDate()).slice(-2);
				return year + "-" + month + "-" + day;
			},
			RefreshCates() {
				this.isloading = true;
				this.axios.get(this.actions.catelist, {
					headers: {
						"Content-Type": "application/json",
					},
					params: {
						pid: '0',
					}
				}).then((response) => {
					this.isloading = false;
					this.categories = response.data;
					//console.log(this.categories);
					this.categories.unshift({
						ID: '0',
						Name: '所有分类',
						Remark: '所有分类',
						Status: true,
						ParentID: 0,
						RootID: 0,
					});
				});
			},
			Refresh() {
				//console.log('Refresh');
				this.isloading = true;
				this.axios.get(this.actions.artlist, {
					headers: {
						"Content-Type": "application/json",
					},
					params: {
						keyword: this.keyword,
						curpage: this.curpage,
						selcate: this.optcateid,
						pagesize: this.pagesize,
						stamp: (new Date()).getTime()
					}
				}).then((response) => {
					//console.log(response.data);
					this.isloading = false;
					this.artlist = response.data.list;
					this.total = parseInt(response.data.totalcount);
					this.curpage = parseInt(response.data.curpage);
					this.pgcurpage = this.curpage;
				});
			},
			Switch(aid, status) {
				console.log("Switch - " + aid + ' - ' + status);
				if(!aid || !status)
					return;
				this.isloading = true;
				this.axios.get(this.actions.artstat, {
					headers: {
						"Content-Type": "application/json",
					},
					params: {
						aid: aid,
						stat: status
					}
				}).then((response) => {
					this.isloading = false;
					console.log(response.data);
					if(response.data.errinfo == 'ok') {
						console.log('ok')
					}
				});
			},
			Add() {
				console.log("Add");
				this.$router.push({
					path: '/article/artdetail'
				});
			},
			Edit(aid) {
				//console.log("Edit - " + aid);
				this.$router.push({
					path: '/article/artdetail',
					query: {
						artid: aid,
						cpage: this.curpage
					}
				});
			},
			Delete(aid) {
				console.log("Delete - " + aid);
				this.$confirm(this.PAGELANG.scczbkhf, {
					type: 'warning',
					callback: (act) => {
						if(act == 'confirm') {
							this.isloading = true;
							this.axios.get(this.actions.delart, {
								headers: {
									"Content-Type": "application/json",
								},
								params: {
									id: aid,
								}
							}).then(() => {
								//console.log(response.data);
								this.isloading = false;
								this.Refresh();
							});
						}
					}
					});
			},
			handleResize() {
				this.clientWidth = document.documentElement.clientWidth;
				this.clientHeight = document.documentElement.clientHeight;
			},
		},
		created() {
			window.addEventListener('resize', this.handleResize);
		},
		mounted() {
			this.viewmode = getCookie('articleviewmode');
			if(!this.viewmode)
				this.viewmode = '2';
				
			this.Refresh();
			this.RefreshCates();
		},
		components: {
			iconfont
		}
	}
